export default __webpack_public_path__ + "static/media/WAS0070.34I-35323_-20471_0.a1ad3d6b.jpg";